module.exports = __webpack_public_path__ + "f4b3150eeda123b30ca58f59f5ecfc85.svg";